import { Fragment, useEffect, useState } from "react";
import React from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { CircularProgress, Divider } from "@mui/material";
import { Container } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
// import isEmail from "validator/lib/isEmail";
// import contains from "validator/lib/contains";
// import FormHelperText from "@material-ui/core/FormHelperText";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";

import useHttp from "../hooks/use-http";
// import { Stack } from "@mui/system";

const Activate = () => {
  const [searchParams] = useSearchParams();
  const activationToken = searchParams.get("activationToken");
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLeadingState, setIsLeadingState] = useState(true);
  const { isLoading, isError, sendRequest: verifyAccount } = useHttp();
  // console.log(searchParams.get("activationToken"));
  

  // console.log(activationToken,"useParams")
  const verifyAccountResponse = (res: any) => {
    if (res.error === true) {
      // setIsLoggedInState(true);
      setErrorMessage(res.message);
    } else {
      setErrorMessage(null);
    }
    setIsLeadingState(false);
  };

  useEffect(() => {
    if (!activationToken) navigate("/login");

    verifyAccount(
      {
        URL: "/api/account-activate?activationToken=" + activationToken,
        method: "GET",
        header: {
          "Content-Type": "application/json",
        },
      },
      verifyAccountResponse
    );
  }, []);

  return (
    <Fragment>
      <Container
        component="main"
        maxWidth={false}
        disableGutters
        sx={{ height: "100vh" }}
      >
        <Box
          sx={{
            margin: 0,
            height: "100vh",
          }}
        >
          <Grid container>
            <CssBaseline />

            <Grid
              item
              xs={12}
              sm={12}
              // md={0}
              component={Paper}
              elevation={0}
              square
            >
              <Grid
                sx={{
                  mx: 4,
                  display: "flex",
                  height: "100vh",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "Space-between",
                }}
              >
                <Grid>
                  <Typography variant="body2"> </Typography>
                </Grid>

                <Grid  sx={{ width: "100%", textAlign: "center" }}>
                  <Box mb={3}>
                      <img
                        src="/assets/Primary_logo_black.svg"
                        width="180px"
                      />
                  </Box>
                  <Box>
                    
                    <Typography
                      component="h5"
                      variant="h5"
                      sx={{ fontSize: "30px" }}
                    >
                      
                      {isLeadingState? "Verifing your account..." : errorMessage
                        ? "Account Activation Failed!"
                        : "Account Activation Successful!"}
                    </Typography>
                    <Typography
                      variant="body2"
                      mb={2}
                      mt={1}
                      sx={{ color: "gray", fontSize: "16px" }}
                    >
                      {isLeadingState? "This may take few secends": errorMessage
                        ? "Your account activation link is either invalid or has expired."
                        : "Your account has been activated and is ready for use. Get started now and enjoy uninterrupted access."}
                    </Typography>
                    <Divider light={true} />

                    <Box sx={{ display: "flex", justifyContent: "center" }}>                      

                      <LoadingButton
                        loading={isLeadingState}
                        loadingIndicator={
                          <CircularProgress color="inherit" size={65} />
                        }
                        variant="text"
                        sx={{
                          mt: 3,
                          mb: 2,
                          width: "100px",

                          height: "100px",
                        }}
                      >
                        {!isLeadingState ? (
                          errorMessage ? (
                            <ReportGmailerrorredIcon
                              sx={{ color: "#FF0606", fontSize: "60px" }}
                            />
                          ) : (
                            <CheckCircleOutlineIcon
                              sx={{ color: "#5ACE65", fontSize: "60px" }}
                            />
                          )
                        ) : (
                          ""
                        )}
                      </LoadingButton>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color: errorMessage
                            ? "red"
                            : !errorMessage && isLeadingState === false
                            ? "#5ACE65"
                            : "gray",
                        }}
                      >
                        {!errorMessage && isLeadingState === false ? (
                          <NavLink to="/login">
                            {"Proceed to your account"}
                          </NavLink>
                        ) : (
                          ''
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid mb={2}>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    If your problem persists, contact{" "}
                    <NavLink to="#">SenseOps support</NavLink>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Fragment>
  );
};

export default Activate;
